<template>
  <div class="widget" >
    <i v-if="editable" class="el-icon-fa-trash delete-widget" @click="deleteWidget" ></i>
    <div class="widget-container" >
      <component :is="widget.widget" :options="widget.options" :widget="widget" ></component>
    </div>
  </div>
</template>

<style scoped>
.delete-widget {
    position: absolute;
    top: 0;
    right: 0;
    margin: 5px;
    cursor: pointer;
    z-index: 1000;
}
</style>

<script>
  export default {
    props: {
      widget: {
        required: true,
        type: Object
      },
      mode: {
        required: true,
        type: String
      }
    },
    computed: {
      editable () {
        return this.mode === 'edit'
      }
    },
    methods: {      
      deleteWidget () {
        this.$emit('delete', this.widget)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/macarons/src/components/PortalWidget.vue